"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SubscriptionWizardController = void 0;
var _checkoutUtils = require("@ori/checkout-utils");
var _configurationManager = require("@ori/configuration-manager");
var _environment = require("@ori/environment");
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _testidGenerator = require("@ori/testid-generator");
var _react = require("react");
var _constants = require("./constants");
var _containers = require("./containers");
var _logger2 = require("./logger");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
const SubscriptionWizardController = ({
  translations,
  onBehalfCustomerId
}) => {
  const {
    language
  } = (0, _i18n.useLanguage)();
  const {
    staticApiUrl
  } = (0, _configurationManager.useServiceUrls)(['staticApi']);
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  if ((0, _checkoutUtils.isSSR)()) {
    return null;
  }
  const {
    placement,
    uriTemplate
  } = (0, _utils.getPurchaseOriginsMetaData)(window.location.pathname);
  const translationProps = (0, _utils.getTranslationsProps)({
    language,
    staticApiUrl,
    tenant,
    translations
  });
  (0, _logger2.logDebug)(`Rendering SubscriptionWizardController ...`, '\n\tPurchase origins matadata: ', {
    placement,
    uriTemplate
  }, '\n\tTranslationProps: ', translationProps);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
    logger: _logger2.mainLogger,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
      areaName: `${_constants.APP_NAME}-boundary`,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Suspense, {
        fallback: null,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_testidGenerator.TestIdProvider, {
          team: _testidGenerator.Team.Checkout,
          project: _constants.APP_NAME,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_containers.ApiProvider, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsProvider, {
              ...translationProps,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
                namespace: _constants.translationsNamespace,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_containers.WizardContainer, {
                  placementFromUrl: placement,
                  uriTemplateFromUrl: uriTemplate,
                  onBehalfCustomerId: onBehalfCustomerId,
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_containers.SubscriptionTypesContainer, {})
                })
              })
            })
          })
        })
      })
    })
  });
};
exports.SubscriptionWizardController = SubscriptionWizardController;
